module.exports = __webpack_public_path__ + "img/Daicl.e5e1b742.svg";